const firebaseConfig = {
    apiKey: "AIzaSyDWmyt0nVFB1qGudlZztfXKAeKZwnIKYSc",
    authDomain: "travelpoka-fullstack.firebaseapp.com",
    projectId: "travelpoka-fullstack",
    storageBucket: "travelpoka-fullstack.appspot.com",
    messagingSenderId: "81153413079",
    appId: "1:81153413079:web:3c5339af8b9a0832bc8592"
  };

  export default firebaseConfig;